export default "__VITE_ASSET__U6oibuwS__"